export default __webpack_public_path__ + "static/media/add.78e273a5.svg";